import { render, staticRenderFns } from "./PatternExtension.vue?vue&type=template&id=c980aec6&scoped=true&"
import script from "./PatternExtension.vue?vue&type=script&lang=js&"
export * from "./PatternExtension.vue?vue&type=script&lang=js&"
import style0 from "./PatternExtension.vue?vue&type=style&index=0&id=c980aec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c980aec6",
  null
  
)

export default component.exports